export enum DataAdSlots {
  HOME_PAGE = 'div-gpt-ad-1708424180458-0',
  WINE_PAGE = 'div-gpt-ad-1708423953421-0',
  SEARCH_PAGE_LEFT = 'div-gpt-ad-sky-left',
  SEARCH_PAGE_RIGHT = 'div-gpt-ad-sky-right',
  SEARCH_PAGE_POS1 = 'div-gpt-ad-SRP-pos1',
  SEARCH_PAGE_POS2 = 'div-gpt-ad-SRP-pos2',
  SEARCH_PAGE_POS3 = 'div-gpt-ad-SRP-pos3',
}

export enum DataAdUnitIds {
  HOME_PAGE = '/23012402476/front_page/1',
  WINE_PAGE = '/23012402476/wine_page/in_content',
  SEARCH_PAGE_LEFT = '/23012402476/WEB/Web_SRP_Desktop_Sky_Left',
  SEARCH_PAGE_RIGHT = '/23012402476/WEB/Web_SRP_Desktop_Sky_Right',
  SEARCH_PAGE_POS1 = '/23012402476/WEB/Web_SRP_MPU_banner_pos1',
  SEARCH_PAGE_POS2 = '/23012402476/WEB/Web_SRP_MPU_banner_pos2',
  SEARCH_PAGE_POS3 = '/23012402476/WEB/Web_SRP_MPU_banner_pos3',
}

export enum AdTypes {
  EXTERNAL = 'external',
  BANNER = 'banner',
  CONTENTFUL_PROMO_BANNER = 'contentful_promo_banner',
}

export enum AdPosition {
  TOP = 'top',
  MIDDLE = 'middle',
}

export interface AdInfo {
  ad_unit_id: string;
  div_id: string;
  position: AdPosition;
}

export interface Promotion {
  type: AdTypes;
  external?: AdInfo;
  banner?: AdInfo;
}

export const getExternalAdInfo = ({
  promotions = [],
  position = AdPosition.MIDDLE,
}: {
  promotions: Promotion[];
  position: AdPosition;
}): AdInfo => {
  const externalAd = promotions.find(
    (promotions) =>
      promotions.type === AdTypes.EXTERNAL && promotions?.external?.position === position
  );

  return externalAd?.external;
};

export const adsToBeShown = ({
  promotions = [],
  user,
}: {
  promotions: Promotion[];
  user: any; // as in userContext, would be nice to make it more strict
}): boolean => {
  const showKevelExternalAds = promotions.find(
    (promotions) => promotions.type === AdTypes.EXTERNAL
  );
  if (!showKevelExternalAds || !getExternalAdInfo({ promotions, position: AdPosition.MIDDLE })) {
    return false;
  }

  return !user?.id ? true : !user.is_premium;
};
